import React, { useEffect, useState } from 'react';
import { withTranslations, WithTranslationsProps } from 'react-utilities';
import { Redirect } from 'react-router-dom';
import { Loading } from 'react-style-guide';
import SortDetailGridV2DiscoveryApi from './SortDetailGridV2DiscoveryApi';
import { usePerTabSession } from '../../common/hooks/usePerTabSession';
import bedev2Services from '../../common/services/bedev2Services';
import ErrorStatus from '../../common/components/ErrorStatus';
import { TPageType } from '../../common/types/bedev1Types';
import {
  TOmniRecommendationSort,
  TOmniRecommendationGameSort
} from '../../common/types/bedev2Types';
import { CommonGameSorts } from '../../common/constants/translationConstants';
import { sessionStorageKey } from '../../common/constants/eventStreamConstants';
import gameCarouselTranslationConfig from '../../../../js/react/gameCarousel/translation.config';

export const SortDetailV2DiscoveryApi = ({
  sortName,
  translate
}: { sortName: string } & WithTranslationsProps): JSX.Element => {
  const [sort, setSort] = useState<TOmniRecommendationSort | undefined>(undefined);
  const homePageSessionInfo = usePerTabSession(sessionStorageKey.homePageSessionInfo);
  const [redirect, setRedirect] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const fetchRecommendations = async () => {
    setError(false);
    setSort(undefined);
    try {
      const omniRecommendations = await bedev2Services.getOmniRecommendations(
        TPageType.Home,
        homePageSessionInfo
      );
      const selectedSort = omniRecommendations.sorts.find(sortItem => sortItem.topic === sortName);
      if (selectedSort === undefined) {
        setRedirect(true);
      } else {
        setSort(selectedSort);
      }
    } catch {
      setError(true);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-void
    void fetchRecommendations();
  }, [sortName]);

  // Error in API calls
  if (error) {
    return (
      <div className='game-sort-detail-container'>
        <h3>{translate(CommonGameSorts.LabelGames)}</h3>
        <div className='game-sort-detail'>
          <ErrorStatus
            errorMessage={translate(CommonGameSorts.LabelApiError)}
            onRefresh={fetchRecommendations}
          />
        </div>
      </div>
    );
  }

  // Redirect if recommendation cannot be found
  if (redirect) {
    return <Redirect to='/' />;
  }

  // Recommendations are loaded
  if (sort) {
    return (
      <div className='game-sort-detail-container'>
        <h3>{sortName}</h3>
        <SortDetailGridV2DiscoveryApi
          homePageSessionInfo={homePageSessionInfo}
          sort={sort as TOmniRecommendationGameSort}
          translate={translate}
        />
      </div>
    );
  }

  return <Loading />;
};

export default withTranslations(SortDetailV2DiscoveryApi, gameCarouselTranslationConfig);
